// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => {
	let frameId: number | null = null;

	return (callback: () => void) => {
		if (frameId) {
			cancelAnimationFrame(frameId);
		}

		frameId = requestAnimationFrame(callback);
	};
};
